import Update from "./Update";
import Delete from "./Delete";
import Purchase from "./Purchase";
import Services from "./Services";

import {
  Fade,
  Card,
  Stack,
  Checkbox,
  CardHeader,
  CardContent,
  CardActionArea,
} from "@mui/material";

import { CustomList } from "components";
import { useSelector } from "react-redux";
import { hasRequiredRole } from "helpers";

export default function Model({
  model,
  delay,
  checked,
  refetch,
  isAssign,
  handleSelect,
}) {
  const {
    id,
    title,
    amount,
    is_valid,
    related_to,
    validity_months,
    lab_quantity,
    unit_quantity,
    doctor_quantity,
    details,
  } = model;
  const { roles } = useSelector((state) => state.auth.userInfo);
  const isAdmin = hasRequiredRole(["superadmin"], roles);

  return (
    <>
      <Fade
        in
        timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}
      >
        <Stack direction="row" alignItems="center">
          {isAssign && (
            <Checkbox size="small" checked={checked} onChange={handleSelect} />
          )}
          <Card
            sx={{
              width: "100%",
              position: "relative",
              bgcolor: checked && "action.disabledBackground",
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              title={title}
              action={
                <Stack direction="row" columnGap={0.5}>
                  {isAdmin ? (
                    <>
                      <Update id={id} refetch={refetch} />
                      <Delete id={id} refetch={refetch} />
                    </>
                  ) : Boolean(+is_valid) ? (
                    <Services
                      plan={model}
                      refetch={refetch}
                    />
                  ) : (
                    <Purchase
                      plan={model}
                      price={+amount}
                      refetch={refetch}
                    />
                  )}
                </Stack>
              }
            />
            <CardContent>
              <CustomList
                data={{
                  title:
                    related_to === "unit" ? "مخصوص کلینیک" : "مخصوص لابراتوار",
                  value: validity_months,
                  unit: "ماه",
                  children: [
                    {
                      title: "قیمت",
                      value: +amount,
                      unit: "تومان",
                    },
                    {
                      title: "تعداد پزشک",
                      value: doctor_quantity,
                      unit: "عدد",
                    },
                    {
                      title: "تعداد کلینیک",
                      value: unit_quantity,
                      unit: "عدد",
                    },
                    {
                      title: "تعداد لابراتوار",
                      value: lab_quantity,
                      unit: "عدد",
                    },
                  ],
                }}
              />
            </CardContent>
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: "absolute",
              }}
              disabled={!isAssign}
              onClick={handleSelect}
            />
          </Card>
        </Stack>
      </Fade>
    </>
  );
}
